import { IAPIAction } from "us.collection/interfaces";
import { PowerBIDashboard } from "us.collection.admin/constants/Actions";

const {
  GET_POWERBI_REPORTS,
  GET_POWERBI_REPORTS_SUCCESS,
  GET_POWERBI_REPORTS_FAIL,
} = PowerBIDashboard;

export const powerBIDashboard: Readonly<IAPIAction> = {
  reports: {
    get: (data) => ({
      type: GET_POWERBI_REPORTS,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_POWERBI_REPORTS_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_POWERBI_REPORTS_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
  },
};
